import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import PublicHome from "@/pages/PublicHome";
import Walkin from "@/pages/Walkin";
import UpdateLead from "@/pages/UpdateLead";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminMarketing from "@/pages/AdminMarketing";
import AdminConversions from "@/pages/AdminConversions";
import AdminLeads from "@/pages/AdminLeads";
import AdminReviews from "@/pages/AdminReviews";
import AdminDuty from "@/pages/AdminDuty";
import AdminTeam from "@/pages/AdminTeam";
import AdminOffDays from "@/pages/AdminOffDays";
import AdminSettings from "@/pages/AdminSettings";
import RequireAdmin from "@/components/RequireAdmin";
import TeamLogin from "@/pages/TeamLogin";
import TeamAuth from "@/pages/TeamAuth";
import TeamPanel from "@/pages/TeamPanel";
import TeamLeads from "@/pages/TeamLeads";
import TeamDuty from "@/pages/TeamDuty";
import TeamLog from "@/pages/TeamLog";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicHome />} />
        <Route path="/walkin" element={<Walkin />} />
        <Route path="/update/:lead_id" element={<UpdateLead />} />
        <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
        <Route path="/admin/analytics" element={<RequireAdmin><AdminAnalytics /></RequireAdmin>} />
        <Route path="/admin/analytics/marketing" element={<RequireAdmin><AdminMarketing /></RequireAdmin>} />
        <Route path="/admin/analytics/capi" element={<RequireAdmin><AdminConversions /></RequireAdmin>} />
        <Route path="/admin/leads" element={<RequireAdmin><AdminLeads /></RequireAdmin>} />
        <Route path="/admin/reviews" element={<RequireAdmin><AdminReviews /></RequireAdmin>} />
        <Route path="/admin/duty" element={<RequireAdmin><AdminDuty /></RequireAdmin>} />
        <Route path="/admin/team" element={<RequireAdmin><AdminTeam /></RequireAdmin>} />
        <Route path="/admin/offdays" element={<RequireAdmin><AdminOffDays /></RequireAdmin>} />
        <Route path="/admin/settings" element={<RequireAdmin><AdminSettings /></RequireAdmin>} />
        <Route path="/team" element={<TeamPanel />} />
        <Route path="/team/leads" element={<TeamLeads />} />
        <Route path="/team/duty" element={<TeamDuty />} />
        <Route path="/team/log" element={<TeamLog />} />
        <Route path="/team/login" element={<TeamLogin />} />
        <Route path="/team/auth" element={<TeamAuth />} />
        {/*
          Pass 19 — staff → team rebrand. Old /staff/* URLs (including
          magic-link emails sent before this deploy) keep working. Each
          subroute redirects to its /team/* twin, and the bare /staff
          parent + a wildcard child handle direct visits. Query string
          is preserved automatically by React Router for the /staff/auth
          → /team/auth?token=... magic-link case.
        */}
        <Route path="/staff" element={<Navigate to="/team" replace />} />
        <Route path="/staff/duty" element={<Navigate to="/team/duty" replace />} />
        <Route path="/staff/log" element={<Navigate to="/team/log" replace />} />
        <Route path="/staff/login" element={<Navigate to="/team/login" replace />} />
        <Route path="/staff/auth" element={<TeamAuth />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
